// extracted by mini-css-extract-plugin
export default {"tab":"styles__tab___hVBXO","activeTab":"styles__activeTab___0mTWj"};